export default __webpack_public_path__ + "static/media/set_4_Image-3.2776d008.svg";